import { StudentProgress, Syllabus, Move, Clazz } from "../types";
import ResourceService from "../common/Services/ResourceService";

class StudentProgressService extends ResourceService<StudentProgress> {
  constructor() {
    super({
      path: "/studentProgressions",
      queryKey: "studentProgressions",
    });
  }

  static listStudentProgressions(payload?: {
    clazz?: Clazz["id"];
    move?: Move["id"];
  }) {
    return new StudentProgressService().list(payload);
  }

  static fetchStudentProgressions(id: StudentProgress["id"]) {
    return new StudentProgressService().fetch({ id });
  }

  static createStudentProgressions(
    payload: Partial<StudentProgress> & {
      syllabus: Syllabus["id"];
      move: Move["id"];
    }
  ) {
    return new StudentProgressService().create(payload);
  }

  static updateStudentProgressions({
    id,
    ...payload
  }: Partial<StudentProgress> & {
    id: StudentProgress["id"];
    syllabus: Syllabus["id"];
    move: Move["id"];
  }): Promise<StudentProgress> {
    return new StudentProgressService().update({ ...payload, id });
  }

  static deleteStudentProgressions({
    id,
  }: {
    id: StudentProgress["id"];
  }): Promise<void> {
    return new StudentProgressService().deleteOne({ id });
  }
}

export default StudentProgressService;
